import axios from 'axios'
const centralApiUrl = process.env.VUE_APP_CENTRALAPI_URL;

export default {
  state: {
  },
  mutations: {
  },
  actions: {
    getInstagramMedia() {
      return new Promise((resolve) => {
        axios
          .get(`${centralApiUrl}instagram/feed/tulumoutdoor`)
          .then(({ data }) => {
            resolve(data)
          })
          .catch(this.$errorHandler)
      })
    }
  },
  getters: {
  }
}
